(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{const input=event.target;if(!input.matches('[data-z-product] input[name="id"]'))return;const root=input.closest('[data-z-product]');const price=root.querySelector('[data-z-price]');if(price)price.textContent=input.dataset.price;const button=root.querySelector('[data-z-buy]');button.disabled=input.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:button.dataset.label;});

  } catch(e) { console.error(e); }
})();
})();
